import { doc, getDoc } from "firebase/firestore";
import { db } from "../context/authContext";

// ⚡ volver a la clase real leyendo Firebase
export const volverAClase = async (navigate, uid) => {
  try {
    if (!uid) {
      navigate("/comprobacion");
      return;
    }

    // leer documento del usuario en Firebase
    const userRef = doc(db, "usuarios", uid);
    const snap = await getDoc(userRef);

    if (!snap.exists()) {
      navigate("/comprobacion");
      return;
    }

    const { nombreGym } = snap.data();

    if (!nombreGym || nombreGym === "") {
      // 👉 no está en ninguna clase → comprobación
      navigate("/comprobacion");
    } else if (nombreGym === "free") {
      // 👉 modo libre
      navigate("/homeuser");
    } else {
      // 👉 gym normal
      navigate("/");
    }
  } catch (error) {
    console.error("❌ Error en volverAClase:", error);
    navigate("/comprobacion");
  }
};
